'use client'

import { useEffect } from 'react'
import { Crisp } from 'crisp-sdk-web'

const CrispChat = () => {
	useEffect(() => {
		Crisp.configure('22a0688d-02ab-43e7-a709-d15e711fa787', {
			autoload: false,
		})
	}, [])

	return null
}

export default CrispChat
